import { Loader } from '@calendly/ui/components/loader';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { TRACKING_EVENT_NAMES, useTrack } from 'hooks/analytics_events';
import { Card } from './card';
import { EmptyState } from './empty_state';
import { mapChangedFiltersForAnalytics } from '../../utils';
import { getMatchTypeFilters } from '../utils';
const containerCss = "c1nwnzqo";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
export const List = ({
  searchQuery,
  meetings,
  isLoading,
  isError,
  selectedMeetingId,
  onSelect,
  filters,
  changedFilters
}) => {
  const track = useTrack();
  if (isLoading) return <Loader />;
  if (isError) return null;
  if (!meetings.length) {
    return <EmptyState query={searchQuery} />;
  }
  const handleClick = (meeting, position) => {
    track({
      name: TRACKING_EVENT_NAMES.SEARCH_INTERACTION,
      properties: {
        search_text: searchQuery,
        search_type: 'text',
        result_count: meetings.length,
        location: 'meetings_search_results',
        action: 'click_result_title',
        filters: mapChangedFiltersForAnalytics(changedFilters),
        match_type: getMatchTypeFilters(filters),
        semantic_search: 'include_related_terms',
        position
      }
    });
    onSelect(meeting);
  };
  return <Container>
      {meetings.map((meeting, index) => <Card key={meeting.uuid} meeting={meeting} selected={selectedMeetingId === meeting.uuid} onSelect={() => handleClick(meeting, index + 1)} position={index + 1} resultsCount={meetings.length} searchQuery={searchQuery} changedFilters={changedFilters} filters={filters} />)}
    </Container>;
};

require("./list.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./list.js");